module.exports = __webpack_public_path__ + "img/recharge.d2dae53.svg";